import { date } from 'quasar'
import ProcessedFileViewModel from '../processedfileviewmodel-dialog-screen.vue';

export default {
    data: function () {
        return {
            title: "Processed Files",
            loading: false,
            channelSettings: {
                ApplicationId: 0,
                SenderId: 0,
                SenderName: "",
                SenderCode: "",
                ReceiverId: 0,
                ReceiverName: "",
                ReceiverCode: "",
                EndPointId: 0
            },
            columns: [
                {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',
                    
                },
                {
                    name: 'EndPointName',
                    label: 'End Point',
                    align: 'left',
                    field: row => row.EndPointName,
                    sortable: true,
                    style: '',
                    
                },
                {
                    name: 'CanonicalId',
                    label: 'Canonical ids',
                    align: 'left',
                    field: row => row.CanonicalId,
                    sortable: false,
                    style: '',
                    
                },
                {
                    name: 'CreatedOn',
                    label: 'Received On',
                    align: 'left',
                    field: row => row.CreatedOn,
                    sortable: true,
                    style: '',
                    format: (val, row) => date.formatDate(val, 'MM/DD/YYYY hh:mm:ss A'),
                },
                {
                    name: 'ScheduledOn',
                    label: 'Scheduled On',
                    align: 'left',
                    field: row => row.ScheduledOn,
                    sortable: false,
                    style: '',
                    format: (val, row) => date.formatDate(val, 'MM/DD/YYYY hh:mm:ss A'),
                },
                {
                    name: 'Processed On',
                    label: 'ProcessedOn',
                    align: 'left',
                    field: row => row.ProcessedOn,
                    sortable: false,
                    style: '',
                    format: (val, row) => date.formatDate(val, 'MM/DD/YYYY hh:mm:ss A'),
                },
                {
                    name: 'Status',
                    label: 'Status',
                    align: 'left',
                    field: row => row.Status,
                    sortable: false,
                    style: '',
                    
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: ''
                },

            ],
            columnsVisible: ['EndPointName', 'CanonicalId', 'CreatedOn', 'ScheduledOn', 'ProcessedOn', 'Status', 'Actions'],
            dataSource: [],
            editRowKey: null,
            filter: null,
            pagination: {
                sortBy: 'CreatedOn',
                descending: true,
                page: 1,
                rowsPerPage: 15,
                rowsNumber: 0 // Need for 'QTable Request' event
            }
        }
    },

    methods: {
        onRequest(props) {
            this.onLoadListDataSource({
                page: props.pagination.page,
                pageSize: props.pagination.rowsPerPage,
                filter: props.filter,
                sortBy: props.pagination.sortBy,
                descending: props.pagination.descending,
            });
        },

        refreshScreen() {
            if (this.channelSettings.ApplicationId > 0 && this.channelSettings.SenderId > 0 && this.channelSettings.ReceiverId > 0 && this.channelSettings.EndPointId > 0) {
                this.title = 'Processed Files - SENDER: ' +
                    this.channelSettings.SenderName +
                    ', RECEIVER: ' +
                    this.channelSettings.ReceiverName;

                this.pagination.page = 1;

                this.onRequest({
                    pagination: this.pagination,
                    filter: this.filter
                });
            } else {
                this.title = 'Processed Files';
                this.dataSource = [];
            }
        },

        async onLoadListDataSource(params) {
            try {
                this.loading = true;

                let startRow = (params.page - 1) * params.pageSize;
                let fetchCount = params.pageSize;

                let requestBody = {
                    Skip: startRow,
                    Take: fetchCount + 1,
                    Filter: params.filter,
                    OrderBy: params.sortBy ? params.sortBy : 'Id',
                    OrderByDescending: params.descending
                };

                let response = await this.$http.post('/api/ui/processed_files/byApplication/' + this.channelSettings.ApplicationId+ '/'+ this.channelSettings.SenderId + '/' + this.channelSettings.ReceiverId + '/' + this.channelSettings.EndPointId, requestBody);
                let listViewDataSource = response.body;

                this.dataSource.splice(0, this.dataSource.length, ...listViewDataSource.Rows);
                
                this.pagination.page = params.page;
                this.pagination.rowsPerPage = params.pageSize;
                this.pagination.sortBy = params.sortBy;
                this.pagination.descending = params.descending;

                if (listViewDataSource.TotalRows) {
                    this.pagination.rowsNumber = listViewDataSource.TotalRows;
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },
        
        onViewActionClick(rowKey, rowIndex, row) {
            this.$q.dialog({
                component: ProcessedFileViewModel,
                parent: this,
                index: rowIndex,
                modelId: rowKey,
                modelObject: row,
                actionTitle: 'Processed File Details',
                editMode: false
            }).onOk((payload) => {
                var currentItemIndex = this.dataSource.map(e => { return e.Id; }).indexOf(rowKey);
                this.dataSource.splice(currentItemIndex, 1, payload.model);
            });
        },

        async onProcessActionClick(rowKey) {
            try {
                this.loading = true;

                let response = await this.$http.post('/api/ui/processed_files/' + rowKey + '/process', this.model, {  });
                this.$processServerJsonResponse(response.body, this.refreshScreen);
                
                return true;
            }
            catch (ex) {
                this.$processException(ex);
                return false;
            }
            finally {
                this.loading = false;
            }
        },

        onDownloadActionClick(rowKey) {
            try {
                this.loading = true;
                window.location.href = '/api/ui/processed_files/' + rowKey + '/download';
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },
    },

    watch: {
        channelSettings: 'refreshScreen'
    }
}